export default "__VITE_ASSET__Dgt1OJy6__"